






























import Vue from "vue";
import { mapGetters } from "vuex";
import SupplierInfo from "../components/Profile/SupplierInfo.vue";
import AffiliateInfo from "../components/Profile/AffiliateInfo.vue";

export default Vue.extend({
  name: "Home",

  data: () => ({}),

  components: {
    AffiliateInfo,
    SupplierInfo,
  },

  computed: {
    ...mapGetters({
      user: "user",
      suppliers: "suppliers",
    }),
  },
});
